const GuestUserFieldsForGetContractWhere = [ 'id' ];

export { GuestUserFieldsForGetContractWhere };
